/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { GET_SUBENTERPRISES, SET_SELECTED_SUBENTERPRISE, SET_FILTERED_SUBENTERPRISES, SET_ENTITLEMENTS_FOR_SUBENTERPRISE, RESET_SUBENTERPRISES } from "./types";

export interface ISubEnterprise {
  id: number;
  name: string;
  displayName: string;
  costCenter: string;
}

export const getAllSubEnterpriseAction = (subEnterprises, selectedSubEnterprise, noSubEnterprise) => {
  return {
    type: GET_SUBENTERPRISES,
    subEnterprises,
    selectedSubEnterprise,
    noSubEnterprise,
  };
};

export const setFilteredSubEnterpriseAction = (filteredSubEnterprises: ISubEnterprise[]) => {
  return {
    type: SET_FILTERED_SUBENTERPRISES,
    filteredSubEnterprises,
  };
};

export const setSelectedSubEnterprisesAction = (selectedSubEnterprise: any) => {
  return {
    type: SET_SELECTED_SUBENTERPRISE,
    selectedSubEnterprise,
  };
};

export const setEntitlementsForSubEnterprise = (entitlements: any) => {
  return {
    type: SET_ENTITLEMENTS_FOR_SUBENTERPRISE,
    entitlements,
  };
};

export const resetAccountsAction = () => {
  return {
    type: RESET_SUBENTERPRISES,
    realms: [],
    selectedRealm: {},
    noRealm: false,
  };
};
